import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pill } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const witaTime = (iso) => {
  try { return new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Makassar" }) + " WITA"; }
  catch (e) { return ""; }
};

export default function PharmacyNotifBell({ items = [], onRead, testid = "pharm-notif-bell", alignLeft = false }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const go = () => {
    setOpen(false);
    api.post("/pharmacy/notifications/read").then(() => onRead && onRead()).catch(() => {});
    navigate("/farmasi?tab=Diajukan");
  };

  return (
    <div className="relative">
      <button data-testid={testid} onClick={() => setOpen((o) => !o)} aria-label="Notifikasi Farmasi" className="relative rounded-xl p-2 text-slate-600 transition-colors hover:bg-[#EEE6FF]">
        <Pill size={24} weight="duotone" />
        {items.length > 0 && (
          <span data-testid={`${testid}-count`} className="absolute -right-0.5 -top-0.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#7C3AED] px-1 text-[10px] font-bold text-white">{items.length > 99 ? "99+" : items.length}</span>
        )}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div data-testid={`${testid}-panel`} className={`absolute ${alignLeft ? "left-0" : "right-0"} z-50 mt-2 w-72 max-w-[85vw] rounded-2xl border border-purple-100 bg-white shadow-xl`}>
            <p className="border-b border-slate-100 px-4 py-3 font-heading text-sm font-bold text-slate-800">Notifikasi Farmasi</p>
            <div className="max-h-72 overflow-y-auto">
              {items.length === 0 ? <p className="px-4 py-6 text-center text-sm text-slate-400">Belum ada notifikasi.</p> : items.map((it) => (
                <button key={it.id} data-testid={`pharm-notif-item-${it.id}`} onClick={go} className="flex w-full flex-col items-start gap-0.5 border-b border-slate-50 px-4 py-2.5 text-left transition-colors hover:bg-[#F7F0FF]">
                  <span className="text-sm font-bold text-slate-800">{it.message}</span>
                  <span className="text-xs text-slate-400">{witaTime(it.created_at)}</span>
                </button>
              ))}
            </div>
            <button data-testid={`${testid}-open-queue`} onClick={go} className="w-full rounded-b-2xl bg-[#EEE6FF] py-2.5 text-center text-sm font-bold text-[#6A38C7] hover:bg-purple-100">Buka Menunggu Verifikasi</button>
          </div>
        </>
      )}
    </div>
  );
}
